import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { of } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'
import {
  CreateNotDeliveredReasonFailure,
  CreateNotDeliveredReasonRequest,
  CreateNotDeliveredReasonSuccess,
  DeleteNotDeliveredReasonFailure,
  DeleteNotDeliveredReasonRequest,
  DeleteNotDeliveredReasonSuccess,
  FetchNotDeliveredReasonRequest,
  FetchNotDeliveredReasonSuccess,
  FetchNotDeliveredReasonFailure,
  FetchNotDeliveredReasonListRequest,
  FetchNotDeliveredReasonListSuccess,
  FetchNotDeliveredReasonListFailure,
  UpdateNotDeliveredReasonFailure,
  UpdateNotDeliveredReasonRequest,
  UpdateNotDeliveredReasonSuccess,
} from './not-delivered-reason.actions'
import { NotDeliveredReasonService } from './not-delivered-reason.service'
import * as NotDeliveredReasonTypes from './not-delivered-reason.types'

@Injectable()
export class NotDeliveredReasonEffects {
  constructor(
    private actions: Actions,
    private notDeliveredReasonService: NotDeliveredReasonService,
    private router: Router,
  ) {}

  FetchNotDeliveredReasonList$ = createEffect(() =>
    this.actions.pipe(
      ofType(NotDeliveredReasonTypes.FETCH_NOT_DELIVERED_REASON_LIST_REQUEST),
      switchMap((action: FetchNotDeliveredReasonListRequest) => {
        return this.notDeliveredReasonService
          .fetchNotDeliveredReasonList(action.payload)
          .pipe(
            map((result) => {
              return new FetchNotDeliveredReasonListSuccess(
                result.data.results,
                result.data.totalCount,
                result.data.filteredCount,
              )
            }),
            catchError((err, caught) => {
              return of(new FetchNotDeliveredReasonListFailure({ error: err }))
            }),
          )
      }),
    ),
  )

  FetchNotDeliveredReason$ = createEffect(() =>
    this.actions.pipe(
      ofType(NotDeliveredReasonTypes.FETCH_NOT_DELIVERED_REASON_REQUEST),
      switchMap((action: FetchNotDeliveredReasonRequest) => {
        return this.notDeliveredReasonService
          .fetchNotDeliveredReason(action.id)
          .pipe(
            map((result) => {
              return new FetchNotDeliveredReasonSuccess(result.data)
            }),
            catchError((err, caught) => {
              return of(new FetchNotDeliveredReasonFailure({ error: err }))
            }),
          )
      }),
    ),
  )

  DeleteNotDeliveredReason$ = createEffect(() =>
    this.actions.pipe(
      ofType(NotDeliveredReasonTypes.DELETE_NOT_DELIVERED_REASON_REQUEST),
      switchMap((action: DeleteNotDeliveredReasonRequest) => {
        return this.notDeliveredReasonService
          .deleteNotDeliveredReason(action.id)
          .pipe(
            switchMap((result) => {
              return [new DeleteNotDeliveredReasonSuccess()]
            }),
            catchError((err, caught) => {
              return of(new DeleteNotDeliveredReasonFailure({ error: err }))
            }),
          )
      }),
    ),
  )

  CreateNotDeliveredReason$ = createEffect(() =>
    this.actions.pipe(
      ofType(NotDeliveredReasonTypes.CREATE_NOT_DELIVERED_REASON_REQUEST),
      switchMap((action: CreateNotDeliveredReasonRequest) => {
        return this.notDeliveredReasonService
          .createNotDeliveredReason(action.payload)
          .pipe(
            switchMap((result) => {
              this.router.navigate(['/admin/not-delivered-reason'])
              return [new CreateNotDeliveredReasonSuccess()]
            }),
            catchError((err, caught) => {
              return of(new CreateNotDeliveredReasonFailure({ error: err }))
            }),
          )
      }),
    ),
  )

  UpdateNotDeliveredReason$ = createEffect(() =>
    this.actions.pipe(
      ofType(NotDeliveredReasonTypes.UPDATE_NOT_DELIVERED_REASON_REQUEST),
      switchMap((action: UpdateNotDeliveredReasonRequest) => {
        return this.notDeliveredReasonService
          .updateNotDeliveredReason(action.id, action.payload)
          .pipe(
            switchMap((result) => {
              this.router.navigate(['/admin/not-delivered-reason'])
              return [
                new FetchNotDeliveredReasonRequest(action.id),
                new UpdateNotDeliveredReasonSuccess(),
              ]
            }),
            catchError((err, caught) => {
              return of(new UpdateNotDeliveredReasonFailure({ error: err }))
            }),
          )
      }),
    ),
  )
}
